import * as React from 'react';
import { colors } from '../../../index';

const IconDownload = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 14 13",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.363 7.586a.62.62 0 00-.622.62v2.117a.793.793 0 01-.792.791H2.05a.793.793 0 01-.792-.79V8.205a.62.62 0 00-1.243 0v2.117c0 1.12.913 2.032 2.035 2.032h9.898a2.036 2.036 0 002.035-2.032V8.206a.62.62 0 00-.621-.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.267 4.239a.622.622 0 00-.878 0L7 6.623 4.612 4.24a.622.622 0 00-.88 0 .62.62 0 000 .877L6.561 7.94a.622.622 0 00.878 0l2.828-2.823a.62.62 0 000-.877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0c-.343 0-.621.203-.621.453v7.215c0 .25.278.453.621.453.343 0 .621-.203.621-.453V.453C7.621.203 7.343 0 7 0z"
  })));
};

export default IconDownload;